import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class FreeDataArgs extends BasicEntity {
action: string;
code: string;
dataType: string;
datas: string;
defaultSize: number | null;
editRestrictMessage: TranslatedEmb;
fdid: number | null;
format: string;
freeDataCode: string;
label: TranslatedEmb;
lock: string;
maxValue: number | null;
minValue: number | null;
regex: string;
restrict: string;
settings: Object;
upper: boolean | null;
validator: string;
valor: string;
valorTrigger: string;
valueControlMessage: TranslatedEmb;
}

